import { DASHBOARD_CHART_TYPES } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "ChartTypeMenu",
  components: {}
})
export default class ChartTypeMenu extends Vue {
  @Prop({ default: 0 }) readonly default!: string | number;
  @Prop({ default: false }) readonly stackedCharts!: boolean;

  TOOLTIP = "Tipo Gráfica";
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN_M0;

  currentChartTypeIndex = 0;
  menuOpen = false;

  get filteredChartTypes() {
    return DASHBOARD_CHART_TYPES.filter(
      chart => chart.stacked === this.stackedCharts
    );
  }

  mounted() {
    this.setInitialChartType();
  }

  @Watch("stackedCharts")
  onStackedChange() {
    this.setInitialChartType();
  }
  setInitialChartType() {
    const list = this.filteredChartTypes;

    if (typeof this.default === "number") {
      this.currentChartTypeIndex =
        this.default >= 0 && this.default < list.length ? this.default : 0;
    } else if (typeof this.default === "string") {
      const foundIndex = list.findIndex(c => c.value === this.default);
      this.currentChartTypeIndex = foundIndex !== -1 ? foundIndex : 0;
    } else {
      this.currentChartTypeIndex = 0;
    }

    this.emitChartType(list[this.currentChartTypeIndex]?.value);
  }

  onChartTypeChange(index: number) {
    const selected = this.filteredChartTypes[index];
    if (selected) {
      this.emitChartType(selected.value);
      this.menuOpen = false;
    }
  }

  emitChartType(value: string) {
    this.$emit("chartTypeChanged", value);
  }
}
